<div class="card-responsive card-responsive-small">
  <div class="card-body">
    <div class="text-center">
      <div class="headline-x-small mb-6">
        @if (!parkingSessionStatus || !parkingSessionStatus.signup_search) {
          <span [innerText]="'Onboarding.NoCurrentParkingSession' | translate"></span>
        } @else if (parkingSessionStatus.signup_search === 'open_session' || parkingSessionStatus.signup_search === 'cleared_session') {
          <span [innerText]="'Onboarding.CurrentParkingSessions' | translate"></span>
        }
      </div>

      <arivo-license-plate
        [country]="licensePlate?.license_plate_country"
        [licensePlate]="licensePlate?.license_plate"
        [checkInvalid]="true"
      />
      <button class="button-primary-text mx-auto mt-2" (click)="previous()" [innerText]="'Common.Change' | translate"></button>

      <div class="mt-4 mb-8">
        @if (!parkingSessionStatus || !parkingSessionStatus.signup_search) {
          <div class="headline-x-small mb-4" [innerText]="'Onboarding.IsYourLicensePlateCorrect' | translate"></div>
          <p class="body-medium" [innerText]="'Onboarding.WeWereNotAbleToFindACurrentParkingSession' | translate"></p>
        } @else if (parkingSessionStatus.signup_search === 'open_session') {
          <p class="body-medium mb-4" [innerText]="'Onboarding.SignUpAndExitLocation' | translate"></p>
        } @else if (parkingSessionStatus.signup_search === 'cleared_session') {
          <div class="headline-x-small mb-4" [innerText]="'Onboarding.YouCanExit' | translate"></div>
          <p class="body-medium mb-2" [innerText]="'Onboarding.YouAreAlreadyRegisteredWithThisLicensePlate' | translate"></p>
        } @else if (parkingSessionStatus.signup_search === 'active_access') {
          <div class="headline-x-small mb-4" [innerText]="'Onboarding.YourLicensePlateAlreadyHasAContract' | translate"></div>
          <p class="body-medium mb-2" [innerText]="'Onboarding.RegisterNowToManageYourContracts' | translate"></p>
        }
      </div>

      @if (!parkingSessionStatus || !parkingSessionStatus.signup_search) {
        <arivo-step-footer [center]="true">
          <button class="button-primary" (click)="next()" [innerText]="'Onboarding.SignUpNow' | translate"></button>
          <button
            class="button-primary-outlined"
            [routerLink]="publicProductsPageEnabled ? ['/public/products'] : ['/login']"
            [innerText]="'Common.Cancel' | translate"
          ></button>
        </arivo-step-footer>
      } @else if (parkingSessionStatus.signup_search === 'open_session') {
        <arivo-step-footer [center]="true">
          <button class="button-primary" (click)="next()" [innerText]="'Onboarding.SignUpNowAndExit' | translate"></button>
          <button
            class="button-primary-outlined"
            [routerLink]="publicProductsPageEnabled ? ['/public/products'] : ['/login']"
            [innerText]="'Common.Cancel' | translate"
          ></button>
        </arivo-step-footer>
      } @else if (parkingSessionStatus.signup_search === 'cleared_session' || parkingSessionStatus.signup_search === 'active_access') {
        <arivo-step-footer [center]="true">
          <button class="button-primary" (click)="next()" [innerText]="'Onboarding.SignUpNow' | translate"></button>
          <button
            class="button-primary-outlined"
            [routerLink]="publicProductsPageEnabled ? ['/public/products'] : ['/login']"
            [innerText]="'Common.Cancel' | translate"
          ></button>
        </arivo-step-footer>
      }
    </div>
  </div>
</div>
